import type { SalesStage } from '../../../api';
import { SALES_STAGE_GROUPS } from '../../../lib/onvizOrderJourney';
import { SALES_STAGE_META } from './crmLabels';

type Props = {
  stage: SalesStage;
  onSelect: (next: SalesStage) => void;
  disabled?: boolean;
};

export function CrmSalesStageGroups({ stage, onSelect, disabled }: Props) {
  return (
    <div className="space-y-3">
      {SALES_STAGE_GROUPS.map((group) => (
        <div key={group.id}>
          <p className="text-[10px] font-bold uppercase mb-1" style={{ color: 'var(--text-3)' }}>
            {group.title}
            <span className="font-normal normal-case ml-1">· {group.subtitle}</span>
          </p>
          <div className="flex flex-wrap gap-1.5">
            {group.stages.map((s) => {
              const meta = SALES_STAGE_META[s];
              const active = stage === s;
              return (
                <button
                  key={s}
                  type="button"
                  disabled={disabled}
                  onClick={() => onSelect(s)}
                  className="press px-2.5 py-2 rounded-lg text-[11px] font-bold touch-manipulation min-h-[44px] disabled:opacity-40"
                  style={
                    active
                      ? { background: meta.bg, color: meta.color, border: `1px solid ${meta.border}` }
                      : {
                          background: 'rgba(255,255,255,0.04)',
                          color: 'var(--text-3)',
                          border: '1px solid var(--border-subtle)',
                        }
                  }
                >
                  {meta.label}
                </button>
              );
            })}
          </div>
        </div>
      ))}
      <div>
        <p className="text-[10px] font-bold uppercase mb-1" style={{ color: 'var(--text-3)' }}>
          Закрытие
        </p>
        <button
          type="button"
          disabled={disabled}
          onClick={() => onSelect('lost')}
          className="press px-2.5 py-2 rounded-lg text-[11px] font-bold touch-manipulation min-h-[44px] disabled:opacity-40"
          style={
            stage === 'lost'
              ? { background: SALES_STAGE_META.lost.bg, color: SALES_STAGE_META.lost.color, border: `1px solid ${SALES_STAGE_META.lost.border}` }
              : { background: 'rgba(255,255,255,0.04)', color: 'var(--text-3)', border: '1px solid var(--border-subtle)' }
          }
        >
          {SALES_STAGE_META.lost.label}
        </button>
      </div>
    </div>
  );
}
